// extracted by mini-css-extract-plugin
export var subtitle = "_c2-2";
export var title = "_c2-0";
export var titleNoWrap = "_c2-1";